import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTagGoal = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zM6.664 7.978a.93.93 0 101.314-1.314.93.93 0 00-1.314 1.314zm3.872-2.318l5.189 5.181v-.003a.93.93 0 01.205 1.015.888.888 0 01-.205.297l-3.575 3.575a.93.93 0 01-.652.275.89.89 0 01-.651-.275L5.66 10.528a2.16 2.16 0 01-.467-.724A2.239 2.239 0 015 8.954V5.93a.891.891 0 01.275-.654A.891.891 0 015.921 5h3.025c.293.008.582.073.85.192.275.106.526.265.74.468z",
		fill: "#7A7370"
	})
});
export default SvgIconTagGoal;
